export const LOGIN = "/auth/login";
export const ALLROLES = "/policies/list/roles";
export const REGISTER = "/auth/register";
export const ALLUSERS = "/users/list";
export const USERDETAILS = "/users";
export const REMOVEUSERROLES = "/Role/removerole";
// export const EVENTTAGS = "/tags";
// export const ALLEVENTTAGS = EVENTTAGS + "/list";
// export const CREATEEVENTTAGS = EVENTTAGS + "/create";
export const GETDASHBOARDTAGDATA = "/dashboard/tagdata";
export const GETUSERMETRICS = "/dashboard/userdata";
export const GETMODULEACTIONS = "/policies/list/moduleactions";
export const CREATEROLE = "/policies/createrank";
export const GETUSERSFORROLE = "/users";
export const SENDRESETLINK = "/auth/resetpassword";
export const VERIFYRESETTOKEN = "/auth/verifyresettoken";
export const CREATEGROUP = "/conversations/creategroup";
export const CREATERANK = "/ranks/add";
export const GETALLRANKUSERS = "/ranks/listusers";
export const REMOVERANKFROMUSER = "/ranks/remove";
export const REMOVERANK = "/ranks";
export const EVENTS = "/eventtags/lists";
export const ALLEVENTS = "/eventtags/allevents";
export const CREATEEVENTTAGS = "/eventtags/createevent";
export const GETEVENTUSERS = "/eventtags/eventusers";
export const DELETEEVENT = "eventtags/deleteevent/";
export const UPDATEEVENT = "eventtags/updateevent";
export const GETALLLISTUSERS = "/ranks/listusersdetails";
export const GETALLGROUPDETAILS = "/groups/groupgrid";
export const GROUPS = "/groups";
export const CREATETAG = "/eventtags/createtag";
export const UPDATETAG = "/eventtags/updatetag";
export const GETALLTAGS = "/eventtags/alltags";
export const REMOVETAG = "/eventtags/deletetag/";
export const GETRECENTGROUPSANDEVENTS = "/dashboard/activity";
export const GETCHARTDATA = "/dashboard/chartdata";
export const GETTAGRESPONSESBYEVENTID = "/eventtags/tagresponses/";
export const GETUSERANALYTICS = "/useranalytics/activity";
export const GETDISTRIBUTIONFORWARDS = "/useranalytics/distributionforwards";
export const GETFORWARDSRECIPIENTS = "/useranalytics/forwardsrecipients";
export const GETMANDATORYMESSAGES = "/useranalytics/mandatorymessages";
export const GETMESSAGESTATISTICS = "/useranalytics/messagestatistics";
export const EVENTNAMES = "/eventtags/eventsgrid";
export const GETMANDATORYMESSAGEOVERALLSTATS =
  "/dashboard/mandatory/overallstats";
export const GETMESSAGESGRID = "/dashboard/mandatory/messagesgrid";
export const GETDEADLINESTATUSSTATS = "/dashboard/mandatory/deadlinestatus";
export const GETMESSAGERECIPIENTS = "/dashboard/messagerecipientslevels";
export const GETEVENTSOVERVIEW = "/dashboard/events/overview";
export const GETEVENTSRESPONSERATE = "/dashboard/events/responserate";
export const GETEVENTSRESPONSERATEGRID = "/dashboard/events/responserategrid";
export const GETMESSAGERECIPIENTSSTATS = "/useranalytics/recipients";
export const GRIDROLES = "/roles/grid";
export const GETRANKSLITE = "/ranks/lite";
export const GETROLESLITE = "/roles/lite";
export const CREATEGROUPBYROLE = "/groups/createbyrole";
export const CREATEGROUPBYRANK = "/groups/createbyrank";
export const GETLITEUSERS = "/users/list/basic";
export const GETAISUMMARYMESSAGES = "/feature/aisummarygrid";
export const REMOVEAISUMMARYMESSAGE = "/feature/aisummary/";
export const REQUESTOTP = "/auth/requestotp";
export const VERIFYOTP = "/auth/verifyotp";
export const GETMANDATORYREPLYMESSAGES =
  "/useranalytics/mandatoryreplymessages/";
export const GETREPLYRECIPIENTS = "/useranalytics/replyrecipients/";
export const ACTIVATEUSER = "/users/activate/";
export const DEACTIVATEUSER = "/users/deactivate/";
export const ALLMESSAGES = "/odata/allmessages";
export const GETTAGRESPONSESBYEVENTMSGID = "/eventtags/tagresponses/message/";
export const BULKINVITEUSERS = "/users/bulkupload";
export const ROLES = "/roles";
export const GETASSEMBLYCONSTITUENCYLIST = "/assemblyConstituency/list";
export const ASSEMBLYCONSTITUENCY = "/assemblyConstituency";
export const GETASSEMBLYCONSTITUENCBYZONEID = "/assemblyConstituency/zone";
export const GETASSEMBLYCONSTITUENCYGRID = "/assemblyConstituency/grid";
export const GETZONELIST = "/zone/list";
export const ZONE = "/zone";
export const GETZONEGRID = "/zone/grid";
export const GETZONESOFRIO = "/zone/rio";
export const RIO = "/rio";
export const GETRIOLIST = "/rio/list";
export const GETRIOGRID = "/rio/grid";
